<template>
  <div class="search-container">
    <el-form ref="form" inline>
      <el-form-item label="供应商名称" label-width="90px">
        <el-input v-model="queryParam.companyName" clearable></el-input>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="list(1)">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>供应商列表</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container">
            <el-button type="success" @click="showSupplier()">
              <el-icon><plus /></el-icon>新增供应商
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="suppliers" border>
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column prop="companyName" label="名称"></el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-link type="primary" href="javascript:;" @click="showSupplier(scope.row)">修改</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>

  <el-dialog :title="supplier.sn ? '修改供应商' : '新增供应商'" v-model="saveSupplierVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="supplier" ref="supplier">
      <el-form-item label="供应商名称" label-width="90px">
        <el-input type="text" v-model="supplier.companyName"></el-input>
      </el-form-item>
      <el-button type="primary" @click="saveSupplier">确定</el-button>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "供应商管理",
  data() {
    return {
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      queryParam: {},
      suppliers: [],
      saveSupplierVisible: false,
      supplier: {}
    }
  },
  methods: {
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.$apis.storeSupplier.list(this.pageIndex - 1, this.pageSize, this.queryParam).then(response => {
        this.suppliers = response.data.data
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list(1)
    },
    showSupplier(supplier) {
      this.saveSupplierVisible = true
      if (supplier) {
        Object.assign(this.supplier, supplier)
      } else {
        this.supplier = {}
      }
    },
    saveSupplier() {
      if (!this.supplier.companyName) {
        this.$message.error('请输入供应商名称')
        return
      }
      if (!this.supplier.sn) {
        this.$apis.storeSupplier.add(this.supplier).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '新增成功',
              type: 'success'
            })
            this.saveSupplierVisible = false
            this.list()
          }
        })
      } else {
        this.$apis.storeSupplier.edit(this.supplier).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.saveSupplierVisible = false
            this.list()
          }
        })
      }
    }
  },
  created() {
    this.list()
  }
}
</script>

<style scoped>

</style>